<div class="switch-locations" *ngIf="locationData">
    <div class="header-row">
        <h2 class="header-title">{{ locationData.header }}</h2>
        <div class="header-ctas">
            <button *ngIf="showCancelCTA" class="xm-btn-secondary-light" (click)="onCancel()">{{ locationData.ctas?.cancelCTA }}</button>
            <button class="xm-btn-primary-light" (click)="onSwitch()" [disabled]="!selectedAccountGuid || selectedAccountGuid === currentAccountGuid">{{ locationData.ctas?.switchCTA }}</button>
        </div>
    </div>

    <table class="locations-table">
        <thead>
            <tr class="table-header-row">
                <th class="col-location">
                    <span>{{ locationData.columnHeaders?.location }}</span>
                    <button class="sort-btn" (click)="toggleSort('location')" [attr.aria-label]="'Sort by ' + locationData.columnHeaders?.location">
                        <span class="sort-icon">
                            <span class="arrow-up" [class.active]="sortState.column === 'location' && sortState.direction === 'asc'">&#9650;</span>
                            <span class="arrow-down" [class.active]="sortState.column === 'location' && sortState.direction === 'desc'">&#9660;</span>
                        </span>
                    </button>
                </th>
                <th class="col-account">
                    <span>{{ locationData.columnHeaders?.accountNumber }}</span>
                    <button class="sort-btn" (click)="toggleSort('account')" [attr.aria-label]="'Sort by ' + locationData.columnHeaders?.accountNumber">
                        <span class="sort-icon">
                            <span class="arrow-up" [class.active]="sortState.column === 'account' && sortState.direction === 'asc'">&#9650;</span>
                            <span class="arrow-down" [class.active]="sortState.column === 'account' && sortState.direction === 'desc'">&#9660;</span>
                        </span>
                    </button>
                </th>
                <th class="col-name">
                    <span>{{ locationData.columnHeaders?.friendlyName }}</span>
                    <button class="sort-btn" (click)="toggleSort('name')" [attr.aria-label]="'Sort by ' + locationData.columnHeaders?.friendlyName">
                        <span class="sort-icon">
                            <span class="arrow-up" [class.active]="sortState.column === 'name' && sortState.direction === 'asc'">&#9650;</span>
                            <span class="arrow-down" [class.active]="sortState.column === 'name' && sortState.direction === 'desc'">&#9660;</span>
                        </span>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of displayedRows"
                class="table-data-row"
                [class.selected]="isSelected(row.accountGuid, row.account, row.isOrion)"
                (click)="selectLocation(row.accountGuid, row.account, row.isOrion)">
                <td class="col-location">
                    <label class="radio-label">
                        <input type="radio"
                               name="locationSelect"
                               [value]="row.accountGuid"
                               [checked]="isSelected(row.accountGuid, row.account, row.isOrion)"
                               (change)="selectLocation(row.accountGuid, row.account, row.isOrion)" />
                        <span class="location-text">{{ row.location }}</span>
                    </label>
                </td>
                <td class="col-account">{{ row.account }}</td>
                <td class="col-name">{{ row.name }}</td>
            </tr>
        </tbody>
    </table>

    <div class="view-more-container" *ngIf="showViewMore">
        <button class="xm-btn-secondary-light" (click)="loadMore()">{{ locationData.ctas?.nextPage }}</button>
    </div>
</div>
